import { getDateTimeUSAFormatWithTime } from 'src/constants/helpers';
import { HookDelivery, IntegrationDeliveryErrorKind, IntegrationPause } from '../types';

type DeliveryResult = {
  statusCode: number | null;
  errorKind: IntegrationDeliveryErrorKind | null;
  errorCode?: string | null;
};

export function formatDeliveryResult({ statusCode, errorKind, errorCode }: DeliveryResult): string {
  if (statusCode !== null) {
    return `HTTP ${statusCode}`;
  }
  if (errorKind === 'timeout') {
    return 'Timeout';
  }
  if (errorKind === 'network') {
    return errorCode ? `Network error (${errorCode})` : 'Network error';
  }
  return '-';
}

// The failure count stops moving once the hook is paused, so it is the count that caused the pause
export function formatPauseDescription(pause: IntegrationPause, consecutiveFailures: number): string {
  if (pause.reason === 'manual') {
    return `Paused manually on ${getDateTimeUSAFormatWithTime(new Date(pause.datePaused))}.`;
  }
  const response = pause.statusCode !== null ? ` The last response was HTTP ${pause.statusCode}.` : '';
  return (
    `Paused automatically on ${getDateTimeUSAFormatWithTime(new Date(pause.datePaused))} after ` +
    `${consecutiveFailures} failed deliveries in a row.${response}`
  );
}

const ENTITY_TYPE_LABELS: Record<NonNullable<HookDelivery['entityType']>, string> = {
  message: 'Message',
  contact: 'Contact',
  campaign: 'Campaign',
  appointment: 'Appointment',
};

export function formatDeliveryEntity({ entityType, entityId }: Pick<HookDelivery, 'entityType' | 'entityId'>): string {
  if (!entityType) {
    return '-';
  }
  return entityId ? `${ENTITY_TYPE_LABELS[entityType]} ${entityId}` : ENTITY_TYPE_LABELS[entityType];
}

export function formatEventType(type: string): string {
  return type.replaceAll('_', ' ');
}
